import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scRemoveTermShorthand',
  standalone: true,
})
export class RemoveTermShorthandPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/\(\w+\)/, '').trim();
  }
}
